import httpClient from "../../../custom-hooks/httpClient";
import dayjs from "dayjs";
import { toast } from "react-toastify";

export const getVerificationDetails = async (
  tid,
  setUserData,
  setIsLoadingVerificationDetails,
  setVerificationDetailsError
) => {
  try {
    const { status, data } = await httpClient.get(`/bvn/details?tid=${tid}`);

    if (status === 200) {
      const verifiedDetails = data.data;
      setUserData((prevUserData) => ({
        ...prevUserData,
        first_name: verifiedDetails.first_name,
        middle_name: verifiedDetails.middle_name,
        last_name: verifiedDetails.surname,
        gender: verifiedDetails.gender.toLowerCase(),
        date_of_birth: dayjs(verifiedDetails.date_of_birth).format("YYYY-MM-DD"),
        phone_number: verifiedDetails.phone_number_1,
        bvn: verifiedDetails.bvn,
        nin: verifiedDetails.nin
      }));
    }
  } catch (err) {
    setVerificationDetailsError(err);
    const errorMessage =
      err.response && err.response.data
        ? err.response.data.message
        : "Error fetching details";
    toast.error(errorMessage);
  } finally {
    setIsLoadingVerificationDetails(false);
  }
};
